import { makeRangeSelectList } from '../../../lib/utils/selectUtils';
import {
  BANNER_WIDGET_LAYOUT_TYPE_V2,
  BANNER_WIDGET_LINK_TYPE_V2,
  BRAND_WIDGET_LAYOUT_TYPE_V2,
  EVENT_WIDGET_LAYOUT_TYPE_V2,
  PRODUCT_CONDITION_TYPE_V2,
  PRODUCT_WIDGET_LAYOUT_TYPE_V2,
  TIMEDEAL_WIDGET_LAYOUT_TYPE_V2,
  TIMEDEAL_WIDGET_LINK_TYPE_V2,
  WIDGET_TYPE_V2,
} from '../../../types/widget';
import product_grid_2_X_2 from '../../../static/images/widget/manual/product/product_grid_2_X_2.png';
import product_grid_3_X_2 from '../../../static/images/widget/manual/product/product_grid_3_X_2.png';
import product_swipe_big_1_X_N from '../../../static/images/widget/manual/product/product_swipe_big_1_X_N.png';
import product_swipe_small_1_X_N from '../../../static/images/widget/manual/product/product_swipe_small_1_X_N.png';
import product_gallery_3_X_3 from '../../../static/images/widget/manual/product/product_gallery_3_X_3.png';
import { PRODUCT_DISCOUNT_TYPE_V2 } from '../../../types/product';
import brand_grid_1_X_4 from '../../../static/images/widget/manual/brand/brand_grid_1_X_4.png';
import brand_grid_2_X_2 from '../../../static/images/widget/manual/brand/brand_grid_2_X_2.png';
import brand_scroll_margin_N_X_1 from '../../../static/images/widget/manual/brand/brand_scroll_margin_N_X_1.png';
import brand_scroll_no_margin_N_X_1 from '../../../static/images/widget/manual/brand/brand_scroll_no_margin_N_X_1.png';
import brand_swipe from '../../../static/images/widget/manual/brand/brand_swipe.png';
import event_swipe from '../../../static/images/widget/manual/event/event_swipe.jpg';
import banner_swipe_margin from '../../../static/images/widget/manual/banner/banner_swipe_margin.png';
import banner_swipe_no_margin from '../../../static/images/widget/manual/banner/banner_swipe_no_margin.png';
import banner_swipe_1_dot_5 from '../../../static/images/widget/manual/banner/banner_swipe_1_dot_5.png';
import banner_swipe_2_dot_5 from '../../../static/images/widget/manual/banner/banner_swipe_2_dot_5.png';
import banner_grid_1_X_2 from '../../../static/images/widget/manual/banner/banner_grid_1_X_2.png';
import banner_grid_2_X_2 from '../../../static/images/widget/manual/banner/banner_grid_2_X_2.png';
import banner_scroll_N_X_1 from '../../../static/images/widget/manual/banner/banner_scroll_N_X_1.png';
import time_deal_swipe_1_X_N from '../../../static/images/widget/manual/timeDeal/time_deal_swipe_1_X_N.png';

const WIDGET_PRODUCT_RANDOM_ITEM_COUNT_SELECT_LIST_INFO_V2 = {
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_2X2]: {
    min: 4,
    step: 4,
    count: 5,
  },
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_3X2]: {
    min: 6,
    step: 6,
    count: 5,
  },
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.SWIPE_BIG_1XN]: {
    min: 2,
    step: 1,
    count: 9,
  },
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.SWIPE_SMALL_1XN]: {
    min: 3,
    step: 1,
    count: 8,
  },
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.GALLERY_3X3]: {
    min: 9,
    step: 0,
    count: 1,
  },
};

export const WIDGET_PRODUCT_RANDOM_ITEM_COUNT_SELECT_LIST_V2 = Object.entries(
  WIDGET_PRODUCT_RANDOM_ITEM_COUNT_SELECT_LIST_INFO_V2,
).reduce(
  (sum, [key, value]) => {
    return { ...sum, [key]: makeRangeSelectList(value, '개') };
  },
  {} as { [LayoutType in PRODUCT_WIDGET_LAYOUT_TYPE_V2]: { id: number; name: string }[] },
);

export const WIDGET_TYPE_LABEL_V2 = {
  [WIDGET_TYPE_V2.PRODUCT]: '상품',
  [WIDGET_TYPE_V2.BRAND]: '브랜드',
  [WIDGET_TYPE_V2.EVENT]: '기획전',
  [WIDGET_TYPE_V2.BANNER]: '배너',
  [WIDGET_TYPE_V2.TIMEDEAL]: '타임딜',
};

export const WIDGET_TYPE_SELECT_LIST_V2 = Object.values(WIDGET_TYPE_V2).map((type) => ({
  id: type,
  name: WIDGET_TYPE_LABEL_V2[type],
}));

export const PRODUCT_WIDGET_LAYOUT_TYPE_LABEL_V2 = {
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_2X2]: '그리드 2 X 2',
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_3X2]: '그리드 3 X 2',
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.SWIPE_BIG_1XN]: '스와이프 1 X N (큰 사이즈)',
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.SWIPE_SMALL_1XN]: '스와이프 1 X N (작은 사이즈)',
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.GALLERY_3X3]: '갤러리 3 X 3',
};

export const PRODUCT_WIDGET_LAYOUT_TYPE_IMG_V2 = {
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_2X2]: product_grid_2_X_2,
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_3X2]: product_grid_3_X_2,
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.SWIPE_BIG_1XN]: product_swipe_big_1_X_N,
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.SWIPE_SMALL_1XN]: product_swipe_small_1_X_N,
  [PRODUCT_WIDGET_LAYOUT_TYPE_V2.GALLERY_3X3]: product_gallery_3_X_3,
};

export const BRAND_WIDGET_LAYOUT_TYPE_LABEL_V2 = {
  [BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_1X4]: '그리드 1 X 4',
  [BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_2X2]: '그리드 2 X 2',
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1]: '스크롤 N X 1(공백X)',
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_BLANK_NX1]: '스크롤 N X 1(공백O)',
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SWIPE]: '스와이프',
};

export const BRAND_WIDGET_LAYOUT_TYPE_IMG_V2 = {
  [BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_1X4]: brand_grid_1_X_4,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_2X2]: brand_grid_2_X_2,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_BLANK_NX1]: brand_scroll_margin_N_X_1,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1]: brand_scroll_no_margin_N_X_1,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SWIPE]: brand_swipe,
};

export const EVENT_WIDGET_LAYOUT_TYPE_LABEL_V2 = {
  [EVENT_WIDGET_LAYOUT_TYPE_V2.SWIPE]: '스와이프(자동,넘버링)',
};

export const EVENT_WIDGET_LAYOUT_TYPE_IMG_V2 = {
  [EVENT_WIDGET_LAYOUT_TYPE_V2.SWIPE]: event_swipe,
};

export const BANNER_WIDGET_LAYOUT_TYPE_LABEL_V2 = {
  [BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_MARGIN]: '스와이프(인디케이터,공백O)',
  [BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_NO_MARGIN]: '스와이프(인디케이터,공백X)',
  [BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_1_DOT_5]: '스와이프(1.5개)',
  [BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_2_DOT_5]: '스와이프(2.5개)',
  [BANNER_WIDGET_LAYOUT_TYPE_V2.GRID_1X2]: '그리드 1 X 2',
  [BANNER_WIDGET_LAYOUT_TYPE_V2.GRID_2X2]: '그리드 2 X 2',
  [BANNER_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1]: '스크롤 N X 1(공백X)',
};

export const BANNER_WIDGET_LAYOUT_TYPE_IMG_V2 = {
  [BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_MARGIN]: banner_swipe_margin,
  [BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_NO_MARGIN]: banner_swipe_no_margin,
  [BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_1_DOT_5]: banner_swipe_1_dot_5,
  [BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_2_DOT_5]: banner_swipe_2_dot_5,
  [BANNER_WIDGET_LAYOUT_TYPE_V2.GRID_1X2]: banner_grid_1_X_2,
  [BANNER_WIDGET_LAYOUT_TYPE_V2.GRID_2X2]: banner_grid_2_X_2,
  [BANNER_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1]: banner_scroll_N_X_1,
};

export const TIMEDEAL_WIDGET_LAYOUT_TYPE_LABEL_V2 = {
  [TIMEDEAL_WIDGET_LAYOUT_TYPE_V2.SWIPE_1XN]: '스와이프 1 X N',
};

export const TIMEDEAL_WIDGET_LAYOUT_TYPE_IMG_V2 = {
  [TIMEDEAL_WIDGET_LAYOUT_TYPE_V2.SWIPE_1XN]: time_deal_swipe_1_X_N,
};

export const PRODUCT_WIDGET_LAYOUT_TYPE_SELECT_LIST = Object.values(PRODUCT_WIDGET_LAYOUT_TYPE_V2).map((type) => ({
  id: type,
  name: PRODUCT_WIDGET_LAYOUT_TYPE_LABEL_V2[type],
}));

export const BRAND_WIDGET_LAYOUT_TYPE_SELECT_LIST = Object.values(BRAND_WIDGET_LAYOUT_TYPE_V2).map((type) => ({
  id: type,
  name: BRAND_WIDGET_LAYOUT_TYPE_LABEL_V2[type],
}));

export const EVENT_WIDGET_LAYOUT_TYPE_SELECT_LIST = Object.values(EVENT_WIDGET_LAYOUT_TYPE_V2).map((type) => ({
  id: type,
  name: EVENT_WIDGET_LAYOUT_TYPE_LABEL_V2[type],
}));

export const BANNER_WIDGET_LAYOUT_TYPE_SELECT_LIST = Object.values(BANNER_WIDGET_LAYOUT_TYPE_V2).map((type) => ({
  id: type,
  name: BANNER_WIDGET_LAYOUT_TYPE_LABEL_V2[type],
}));

export const TIMEDEAL_WIDGET_LAYOUT_TYPE_SELECT_LIST = Object.values(TIMEDEAL_WIDGET_LAYOUT_TYPE_V2).map((type) => ({
  id: type,
  name: TIMEDEAL_WIDGET_LAYOUT_TYPE_LABEL_V2[type],
}));

export const PRODUCT_WIDGET_DISCOUNT_TYPE_LABEL_V2 = {
  [PRODUCT_DISCOUNT_TYPE_V2.AMOUNT]: '원',
  [PRODUCT_DISCOUNT_TYPE_V2.PERCENT]: '%',
};

export const PRODUCT_WIDGET_DISCOUNT_TYPE_SELECT_LIST_V2 = [
  {
    id: PRODUCT_DISCOUNT_TYPE_V2.AMOUNT,
    name: PRODUCT_WIDGET_DISCOUNT_TYPE_LABEL_V2[PRODUCT_DISCOUNT_TYPE_V2.AMOUNT],
  },
  {
    id: PRODUCT_DISCOUNT_TYPE_V2.PERCENT,
    name: PRODUCT_WIDGET_DISCOUNT_TYPE_LABEL_V2[PRODUCT_DISCOUNT_TYPE_V2.PERCENT],
  },
];

export const PRODUCT_WIDGET_PRICE_TYPE_SELECT_LABEL_V2 = {
  [PRODUCT_CONDITION_TYPE_V2.SALES]: '실판매가',
  [PRODUCT_CONDITION_TYPE_V2.DISCOUNT]: '할인가',
};

export const PRODUCT_WIDGET_PRICE_TYPE_SELECT_LIST_V2 = [
  {
    id: PRODUCT_CONDITION_TYPE_V2.SALES,
    name: PRODUCT_WIDGET_PRICE_TYPE_SELECT_LABEL_V2[PRODUCT_CONDITION_TYPE_V2.SALES],
  },
  {
    id: PRODUCT_CONDITION_TYPE_V2.DISCOUNT,
    name: PRODUCT_WIDGET_PRICE_TYPE_SELECT_LABEL_V2[PRODUCT_CONDITION_TYPE_V2.DISCOUNT],
  },
];

export const BANNER_WIDGET_LINK_TYPE_LABEL_V2 = {
  [BANNER_WIDGET_LINK_TYPE_V2.BRAND]: '브랜드 상세 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.EVENT]: '기획전 상세 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.PRODUCT_LIST]: '상품 목록 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.BRAND_LIST]: '브랜드 목록 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.LIKE_PRODUCT_LIST]: '찜 상품 목록 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.LIKE_BRAND_LIST]: '찜 브랜드 목록 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.CART]: '장바구니 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.POINT]: '포인트 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.COUPON]: '쿠폰 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.REFERRAL]: '레퍼럴 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.ORDER_DELIVERY_LIST]: '주문 배송 조회 목록',
  [BANNER_WIDGET_LINK_TYPE_V2.PRODUCT_REVIEW_WRITE_TAB]: '상품 후기 쓰기 탭',
  [BANNER_WIDGET_LINK_TYPE_V2.PRODUCT_REVIEW_HISTORY_TAB]: '상품 후기 작성한 내역 탭',
  [BANNER_WIDGET_LINK_TYPE_V2.UPDATE_USER]: '회원정보 수정 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.SET_ALARM]: '알림 설정 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.PRODUCT]: '상품 상세 페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.REVIEW]: '후기 상세',
  [BANNER_WIDGET_LINK_TYPE_V2.TAG_TAB]: '태그 탭',
  [BANNER_WIDGET_LINK_TYPE_V2.TAG_DETAIL_GALLERY]: '태그 상세 - 갤러리',
  [BANNER_WIDGET_LINK_TYPE_V2.TAG_DETAIL_FEED]: '태그 상세 - 피드',
  [BANNER_WIDGET_LINK_TYPE_V2.WEB]: '웹페이지',
  [BANNER_WIDGET_LINK_TYPE_V2.CATEGORY]: '카테고리 페이지',
};

export const BANNER_WIDGET_LINK_TYPE_SELECT_LIST = Object.values(BANNER_WIDGET_LINK_TYPE_V2).map((linkType) => ({
  id: linkType,
  name: BANNER_WIDGET_LINK_TYPE_LABEL_V2[linkType],
}));

export const TIMEDEAL_WIDGET_LINK_TYPE_LABEL_V2 = {
  [TIMEDEAL_WIDGET_LINK_TYPE_V2.PRODUCT]: '상품 상세 페이지',
};

export const TIMEDEAL_WIDGET_LINK_TYPE_SELECT_LIST = Object.values(TIMEDEAL_WIDGET_LINK_TYPE_V2).map((linkType) => ({
  id: linkType,
  name: TIMEDEAL_WIDGET_LINK_TYPE_LABEL_V2[linkType],
}));
